var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.updatedSeries,"height":"350"}})}
var staticRenderFns = []

export { render, staticRenderFns }